<template>
    <section id="wrapper" class="auth-saas auth-saas--pro">
        <div class="auth-saas__layout auth-saas__layout--centered">
            <div class="auth-saas__form-column">
                <div class="auth-saas__form-inner">
                    <div class="auth-saas__card">
                        <div class="auth-saas__user">
                            <img :src="getAuthUser('avatar')" class="auth-saas__avatar" width="72" height="72" alt="">
                            <p class="auth-saas__user-name">{{ getAuthUser('full_name') }}</p>
                        </div>
                        <div class="text-center mb-2">
                            <span class="auth-saas__eyebrow">Two-factor verification</span>
                        </div>
                        <h1 class="auth-saas__title text-center">{{ trans('auth.two_factor_security') }}</h1>
                        <p class="auth-saas__subtitle text-center">Enter the verification code to finish signing in to the admin console.</p>
                        <div class="auth-saas__mini-chip">
                            <span class="auth-saas__status-chip-dot" aria-hidden="true"></span>
                            <span>Two-factor check</span>
                            <kbd>2FA</kbd>
                        </div>
                        <form class="form-validate is-alter" id="twoFactorForm" @submit.prevent="submit" @keydown="twoFactorForm.errors.clear($event.target.name)">
                            <div class="form-group">
                                <label class="auth-saas__label text-center d-block" for="two_factor_code">{{ trans('auth.two_factor_code') }}</label>
                                <input id="two_factor_code" type="text" name="two_factor_code" class="auth-saas__input text-center" inputmode="numeric" autocomplete="one-time-code" :placeholder="trans('auth.two_factor_code')" v-model="twoFactorForm.two_factor_code">
                                <show-error :form-name="twoFactorForm" prop-name="two_factor_code" class="text-danger text-center"></show-error>
                            </div>
                            <div class="form-group mb-0">
                                <button class="auth-saas__btn" type="submit">{{ trans('auth.confirm') }}</button>
                            </div>
                        </form>
                        <div class="auth-saas__note">
                            <a href="#" class="auth-saas__link-muted" @click.prevent="logout"><admin-icon name="logout"></admin-icon> {{ trans('auth.logout') }}</a>
                        </div>
                    </div>
                </div>
                <div class="auth-saas__footer">
                    <guest-footer></guest-footer>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import guestFooter from '../../layouts/guest-footer.vue'

    export default {
        components: {guestFooter},
        data(){
            return {
                twoFactorForm: new Form({
                    two_factor_code: '',
                })
            }
        },
        mounted(){
            if(!helper.getConfig('two_factor_security') || !helper.getTwoFactorCode())
                this.$router.push('/home');

            if(!helper.getConfig('mode'))
                this.twoFactorForm.two_factor_code = helper.getTwoFactorCode();
        },
        methods: {
            logout(){
                helper.logout().then(() => {
                    this.$store.dispatch('resetAuthUserDetail');
                    this.$router.push('/login')
                })
            },
            submit(){
                if(this.twoFactorForm.two_factor_code == helper.getTwoFactorCode()){
                    this.$store.dispatch('resetTwoFactorCode');
                    toastr.success(i18n.auth.two_factor_security_verified);
                    this.$router.push('/home');
                } else {
                    toastr.error(i18n.auth.invalid_two_factor_code);
                }
            },
            getAuthUser(name){
                return helper.getAuthUser(name);
            }
        },
        computed: {
        }
    }
</script>
